'use client';

import { useEffect, useState } from 'react';

import { readActiveOptimizelyCampaigns, subscribeToOptimizelyCampaignChanges } from './readActiveOptimizelyCampaigns';
import type { OptimizelyActiveCampaign } from './types';

/** Tracks active Optimizely Web campaigns while C0002 is granted. */
export function useGetActiveOptimizelyCampaigns(hasC0002: boolean): OptimizelyActiveCampaign[] {
    const [campaigns, setCampaigns] = useState<OptimizelyActiveCampaign[]>([]);

    useEffect(() => {
        if (!hasC0002) {
            setCampaigns([]);
            return;
        }

        let cancelled = false;
        const refresh = () => {
            const next = readActiveOptimizelyCampaigns();
            if (!cancelled) {
                setCampaigns(previous => (JSON.stringify(previous) === JSON.stringify(next) ? previous : next));
            }
        };

        refresh();

        const unsubscribe = subscribeToOptimizelyCampaignChanges(refresh);

        return () => {
            cancelled = true;
            unsubscribe();
        };
    }, [hasC0002]);

    return campaigns;
}
